import { Avatar } from "@mui/material";
import { colors } from "../../../ui/colors";

type CompanyAvatarViewProps = {
  src?: string;
  initial: string;
  size?: number;
  alt?: string;
};

export const CompanyAvatarView = ({ src, initial, size = 48, alt = "Company" }: CompanyAvatarViewProps) => {
  return (
    <Avatar
      src={src}
      alt={alt}
      imgProps={{
        referrerPolicy: "no-referrer",
        onLoad: () => {
          console.log("[CompanyAvatarView] loaded:", src);
        },
        onError: (event) => {
          console.error("[CompanyAvatarView] failed:", {
            src,
            event,
          });
        },
      }}
      sx={{
        width: size,
        height: size,
        bgcolor: colors.orange.base,
        fontSize: size * 0.42,
        fontWeight: 900,

        "& img": {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        },
      }}
    >
      {initial}
    </Avatar>
  );
};
